import React, { Component } from 'react';
import './ProposalForm.css'
import $ from 'jquery';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import API_Config from '../../API_Config';

class ProposalForm extends Component {

    render() {
        return (
            <div className="col-md-4 flash_sidebg">
                <h4>Ask for a Proposal Today</h4>
                <div className="cust_form_bg">
                    <div className="new_form_req" id="new_custom" >
                        <div className="group">
                            <input type="text" name="name" id="name"></input>
                            <span className="highlight"></span>
                            <span className="bar"></span>
                            <label>Name</label>
                        </div>
                        <div className="group">
                            <input type="text" name="phno" id="phno"></input>
                            <span className="highlight"></span>
                            <span className="bar"></span>
                            <label>Mobile Number</label>
                        </div>
                        <div className="group">
                            <input type="text" name="email" id="email"></input>
                            <span className="highlight"></span>
                            <span className="bar"></span>
                            <label>Email Address</label>
                        </div>
                        <div className="group">
                            <input type="text" name="desc" id="desc"></input>
                            <input type="hidden" name="type" id="type" value="custom"></input>
                            <span className="highlight"></span>
                            <span className="bar"></span>
                            <label>Other Message</label>
                        </div>

                        <button onClick={this.handleSubmit} className="col-md-4 submitbutton" id="form_submit">SUBMIT</button>
                    </div>
                </div>

                <NotificationContainer />
            </div>

        );
    }

    handleSubmit() {

        var name = $("#name").val();
        var email = $("#email").val();
        var phone = $("#phno").val();
        var description = $("#desc").val();
        if (email == '') {

            NotificationManager.error('Error', 'Please enter Correct Email !', 5000);
            return false;
        }
        else if (description == '') {
            NotificationManager.error('Error', 'Please enter what you are looking for!', 5000);
            return false;
        }
        else if (email != '' && description != '' && phone!='' && name!='') {

            var atpos = email.indexOf("@");
            var dotpos = email.lastIndexOf(".");
            if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= email.length) {

                NotificationManager.error('Error', 'Enter valid email id!', 5000);
                return false;
            }
            else {
                var postData =
                    {
                        name: name,
                        email: email,
                        phno: phone,
                        desc: description,
                        custom_user_session_id: localStorage.getItem('SessionID')
                    }


                            $.ajax({
                                type: 'POST',
                                url: API_Config.http_url + API_Config.end_point.contactUs,
                                data:postData
                            })
                            .done(function (data) {
                                NotificationManager.success('Success', 'Proposal accepted successfully', 5000);
                                $("#name").val('')
                                $("#email").val('');
                                $("#phno").val('');
                                $("#desc").val('');

                            })
                            .fail(function (jqXhr) {
                                NotificationManager.error('Error', 'Something went wrong!', 5000);
                            });


            }

        }

        else{
            NotificationManager.error('Error', 'Please enter the details!', 5000);
            return false;
        }


    }

}

export default ProposalForm;


// WEBPACK FOOTER //
// ./src/Forms/ProposalForm/ProposalForm.js